import React, { Component,Fragment } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBTableBody,MDBTable, MDBTableHead, MDBAlert, MDBSelect , MDBInput, MDBIcon   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import domtoimage from 'dom-to-image';
import { api, URL } from '../../api';

export default class ModalEditcurriculumopen extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,
  Curriculumopen:[],

  Course_ID:'',
  Curriculumopen_ID:'',
  Course_YEAR:'',
  Curriculumopen_TEAM:'',
  Curriculumopen_Full_Name_TH:'',
  Curriculumopen_Full_Name_EN:'',
  Curriculumopen_Detail_TH:'',
  Curriculumopen_Detail_EN:'',
  Curriculumopen_CH:'',
  Curriculumopen_NUM:'',
  Curriculumopen_Date_STARTRE:'',
  Curriculumopen_Date_ENDRE:'',
  Curriculumopen_Date_START:'',
  Curriculumopen_Date_END:'',
  Curriculumopen_User_UPDATE:'',
  Curriculumopen_Status_COURSE:'1',
  Curriculumopen_Status_ONOFF:'1',
  Univ_ID:'1',
  Univ_NAME:'',
}

//this.handleChange = this.handleChange.bind(this);
this.handleChangeName_EN = this.handleChangeName_EN.bind(this);
this.handleChangeName_TH = this.handleChangeName_TH.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangeteam = this.handleChangeteam.bind(this);
this.handleChangeCH = this.handleChangeCH.bind(this);
this.handleChangeNUM = this.handleChangeNUM.bind(this);
this.handleChangeTIMESTART = this.handleChangeTIMESTART.bind(this);
this.handleChangeEND = this.handleChangeEND.bind(this);
this.handleChangeDetail_TH = this.handleChangeDetail_TH.bind(this);
this.handleChangeDetail_EN = this.handleChangeDetail_EN.bind(this);
this.handleChangeTIMESTARTRE = this.handleChangeTIMESTARTRE.bind(this);
this.handleChangeENDRE = this.handleChangeENDRE.bind(this);

this.getCurriculumopen = this.getCurriculumopen.bind(this);

}


toggle = () => {
  this.setState({
    modal: !this.state.modal,
    Course_ID:this.props.Course_ID
    
  });
  this.getCurriculumopen();
}

getCurriculumopen() {
    setTimeout(() => {
       //ภายใน
       api.get('index/getCurriculumopenregis/'+this.props.Curriculumopen_ID)
       .then(res => {
         console.log(res);
       //  this.setState({ bankname: res.data, loading: false })

         this.setState({ Curriculumopen: res.data})

         
         this.setState({ Course_ID: res.data[0].Course_ID})
         this.setState({ Curriculumopen_ID: res.data[0].Curriculumopen_ID})
         this.setState({ Course_YEAR: res.data[0].Course_YEAR})
         this.setState({ Curriculumopen_TEAM: res.data[0].Curriculumopen_TEAM})
         this.setState({ Curriculumopen_Full_Name_TH: res.data[0].Curriculumopen_Full_Name_TH})
         this.setState({ Curriculumopen_Full_Name_EN: res.data[0].Curriculumopen_Full_Name_EN})
         this.setState({ Curriculumopen_Detail_TH: res.data[0].Curriculumopen_Detail_TH})
         this.setState({ Curriculumopen_Detail_EN: res.data[0].Curriculumopen_Detail_EN})
         this.setState({ Curriculumopen_CH: res.data[0].Curriculumopen_CH})
         this.setState({ Curriculumopen_NUM: res.data[0].Curriculumopen_NUM})
         this.setState({ Curriculumopen_Date_STARTRE: res.data[0].Curriculumopen_Date_STARTRE})
         this.setState({ Curriculumopen_Date_ENDRE: res.data[0].Curriculumopen_Date_ENDRE})
         this.setState({ Curriculumopen_Date_START: res.data[0].Curriculumopen_Date_START})
         this.setState({ Curriculumopen_Date_END: res.data[0].Curriculumopen_Date_END})
         this.setState({ Curriculumopen_User_UPDATE: res.data[0].Curriculumopen_User_UPDATE})
         this.setState({ Curriculumopen_Status_COURSE: res.data[0].Curriculumopen_Status_COURSE})
         this.setState({ Univ_ID: res.data[0].Univ_ID})
       }) 
     }, 0);
  }


//handleChange2(event) {    this.setState({send_comment1: event.target.value});  }


 componentDidMount() {

  const { Curriculumopen_ID } = this.props.Curriculumopen_ID
console.log(Curriculumopen_ID)
  //console.log(id_send);
//   this.setState({ Course_ID:this.props.Course_ID})
//   this.setState({ Course_YEAR:this.props.Course_YEAR})
//   this.setState({ Univ_ID:localStorage.getItem('Univ_ID')})
//   this.setState({ Univ_NAME:localStorage.getItem('Univ_NAME')})
//   this.setState({ Curriculumopen_User_UPDATE:localStorage.getItem('Citizen_ID')})
 
//     Axios.get(`https://arit.kpru.ac.th/ap/survey/api.php?nu=reports&code=20210719&PostionType=%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2&id=${this.props.faculty1send}&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR37lj-5gXs9k55vAErqiHHH-Nyr5WKEzJIY_M_O_fsHzazOYbxbyZwusg4`,
//     // Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
//      {headers: {
//         // Authorization: 'Bearer ' + localStorage.getItem('myData')
//      }
//      })
//    //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
//      .then(res => {
//         // console.log(res.data[0].id)
//          console.log(res.data)
//         // const studentok = res.data.filter( ({ message }) => message === "ฉีดวัคซีนแล้ว" );
//       //  const report8 = res.data.filter( ({ faculty_id }) => faculty_id === "8" );
//        //  const student = res.data;
//         //  this.setState({ studentnum : studentok});
//          const studentnotok = res.data.filter( ({ message }) => message === "ยังไม่ได้ฉีดวัคซีน" );
//          this.setState({ studentnumnot : studentnotok});
//      })

  }



  handleChangeteam(event) {    this.setState({Curriculumopen_TEAM: event.target.value});  }
  handleChangeName_TH(event) {    this.setState({Curriculumopen_Full_Name_TH: event.target.value});  }
  handleChangeName_EN(event) {    this.setState({Curriculumopen_Full_Name_EN: event.target.value});  }
  handleChangeDetail_TH(event) {    this.setState({Curriculumopen_Detail_TH: event.target.value});  }
  handleChangeDetail_EN(event) {    this.setState({Curriculumopen_Detail_EN: event.target.value});  }
  handleChangeCH(event) {    this.setState({Curriculumopen_CH: event.target.value});  }
  handleChangeNUM(event) {    this.setState({Curriculumopen_NUM: event.target.value});  }
  handleChangeTIMESTART(event) {    this.setState({Curriculumopen_Date_START: event.target.value});  }
 // handleChangeTIMESTART(event) {    this.setState({Curriculumopen_Date_START: event.target.value});  }
  handleChangeEND(event) {    this.setState({Curriculumopen_Date_END: event.target.value});  }

  handleChangeTIMESTARTRE(event) {    this.setState({Curriculumopen_Date_STARTRE: event.target.value});  }
  handleChangeENDRE(event) {    this.setState({Curriculumopen_Date_ENDRE: event.target.value});  }




  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("Curriculumopen_ID", this.state.Curriculumopen_ID);
      datafrm.append("Course_ID", this.state.Course_ID);
      datafrm.append("Course_YEAR", this.state.Course_YEAR);
      datafrm.append("Curriculumopen_TEAM", this.state.Curriculumopen_TEAM);
      datafrm.append("Curriculumopen_Full_Name_TH", this.state.Curriculumopen_Full_Name_TH);
      datafrm.append("Curriculumopen_Full_Name_EN", this.state.Curriculumopen_Full_Name_EN);
      datafrm.append("Curriculumopen_Detail_TH", this.state.Curriculumopen_Detail_TH);
      datafrm.append("Curriculumopen_Detail_EN", this.state.Curriculumopen_Detail_EN);
      datafrm.append("Curriculumopen_CH", this.state.Curriculumopen_CH);
      datafrm.append("Curriculumopen_NUM", this.state.Curriculumopen_NUM);
      datafrm.append("Curriculumopen_Date_STARTRE", this.state.Curriculumopen_Date_STARTRE);
      datafrm.append("Curriculumopen_Date_ENDRE", this.state.Curriculumopen_Date_ENDRE);
      datafrm.append("Curriculumopen_Date_START", this.state.Curriculumopen_Date_START);
      datafrm.append("Curriculumopen_Date_END", this.state.Curriculumopen_Date_END);
   //   datafrm.append("Curriculumopen_User_UPDATE", this.state.Curriculumopen_User_UPDATE);
    //  datafrm.append("Curriculumopen_Status_COURSE", this.state.Curriculumopen_Status_COURSE);
     // datafrm.append("Curriculumopen_Status_ONOFF", this.state.Curriculumopen_Status_ONOFF);
    //  datafrm.append("Univ_ID", this.state.Univ_ID);
      
    api.post("index/updateCurriculumopen/",datafrm,{
        headers: {
            'content-type': 'multipart/form-data'
        }
      })

   .then(res => {
    //    console.log(res);
        if (res.status === 200) {
        //  alert("บันทึกสำเร็จ")
                  Swal.fire({
                      title: 'แก้ไขข้อมูลสำเร็จ',
                      icon: 'success',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                    
                    })
                 }
        })
        this.toggle()
        this.getCurriculumopen();
      //  this.props.getclassroom()

}, 1000);

//window.location.href = '/Reportcurriculumall'
//this.props.updateat();
//this.getExpert()
 
  }

    render() {
      //  console.log(this.state.Course_ID)
      //   console.log(this.state.Curriculumopen_Full_Name_TH)
     //    console.log(this.state.Curriculumopen_Detail_EN)
      //   console.log(this.state.Curriculumopen_NUM)
        // console.log(this.state.Curriculumopen_Date_START)
        // console.log(this.state.Curriculumopen_Date_END)



      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
        
        return (
            <>
            {/* <MDBBtn onClick={this.toggle} color="deep-purple" size="sm">รายชื่อยังไม่ได้ฉีดวัคซีน</MDBBtn> */}
            {/* <MDBBtn onClick={this.toggle}  color="deep-purple" > + เพิ่มข้อมูลหลักสูตร</MDBBtn> */}
            <MDBBtn  onClick={this.toggle} color="amber" size="sm" >แก้ไข</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}><MDBIcon icon="edit" /> แก้ไขข้อมูลหลักสูตร</MDBModalHeader>
              <MDBModalBody className="text-left">
               
              <br/>
              <div id="pdfdiv">
              
            
      
                 <div className="form-group">
                    <label htmlFor="example2">รหัสวิชาอ้างอิง</label>
                    <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} disabled  />
                </div>
                <div className="form-group">
                    <label htmlFor="example2">วิชาปี</label>
                    <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_YEAR} disabled  />
                </div>
                <div className="form-group">
                    <label htmlFor="example2">เทอม</label>
                    {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                    <div>
              <select className="browser-default custom-select"  onChange={this.handleChangeteam.bind(this)} value={this.state.Curriculumopen_TEAM} icon="user" >
                <option>เลือกเทอม</option>
                <option value="2/2565">2/2565</option>
                <option value="1/2565">1/2565</option>
                <option value="2/2564">2/2564</option>
                <option value="1/2564">1/2564</option>
             
                </select> <br/>
            </div>
                </div>
                <div className="form-group">
                    <label htmlFor="example2">ชื่อหลักสูตรภาษาไทย</label>
                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ ชื่อหลักสูตรภาษาไทย" value={this.state.Curriculumopen_Full_Name_TH} onChange={this.handleChangeName_TH} />
                </div>
                <div className="form-group">
                    <label htmlFor="example2">ชื่อหลักสูตรภาษาอังกฤษ</label>
                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ ชื่อหลักสูตรภาษาอังกฤษ" value={this.state.Curriculumopen_Full_Name_EN} onChange={this.handleChangeName_EN} />
                </div>
                <div className="form-group">
                    <label htmlFor="example2">คำอธิบายรายวิชาภาษาไทย</label>
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      placeholder="คำอธิบายรายวิชาภาษาไทย"
                      value={this.state.Curriculumopen_Detail_TH} onChange={this.handleChangeDetail_TH} 
                      rows="5"
                      />
                </div>
                <div className="form-group">
                    <label htmlFor="example2">คำอธิบายรายวิชาภาษาอังกฤษ</label>
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      placeholder="คำอธิบายรายวิชาภาษาอังกฤษ"
                      value={this.state.Curriculumopen_Detail_EN} onChange={this.handleChangeDetail_EN} 
                      rows="5"
                      />
                </div>
                <div className="form-group">
                    <label htmlFor="example2">จำนวนชั่วโมง</label>
                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ จำนวนชั่วโมง" value={this.state.Curriculumopen_CH} onChange={this.handleChangeCH} />
                </div>
                <div className="form-group">
                    <label htmlFor="example2">จำนวนที่รับ</label>
                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ จำนวนที่รับ" value={this.state.Curriculumopen_NUM} onChange={this.handleChangeNUM} />
                </div>
                <div className="form-group">
                    <label htmlFor="example2">วันที่ เปิดลงทะเบียน</label>
                    <input type="date" id="example2" className="form-control form-control-md" value={this.state.Curriculumopen_Date_STARTRE} onChange={this.handleChangeTIMESTARTRE}/>
                </div>
                <div className="form-group">
                    <label htmlFor="example2">วันที่ ปิดลงทะเบียน</label>
                    <input type="date" id="example2" className="form-control form-control-md" value={this.state.Curriculumopen_Date_ENDRE} onChange={this.handleChangeENDRE}/>
                </div>
                <div className="form-group">
                    <label htmlFor="example2">วันที่ เปิดการสอน</label>
                    <input type="date" id="example2" className="form-control form-control-md" value={this.state.Curriculumopen_Date_START} onChange={this.handleChangeTIMESTART}/>
                </div>
                <div className="form-group">
                    <label htmlFor="example2">วันที่ ปิดการสอน</label>
                    <input type="date" id="example2" className="form-control form-control-md" value={this.state.Curriculumopen_Date_END}  onChange={this.handleChangeEND}/>
                </div>
                <div className="form-group">
                    <label htmlFor="example2">มหาวิทยาลัย</label>
                    <input type="text" id="example2" className="form-control form-control-md" value={this.state.Univ_NAME} disabled/>
                </div>
               
            
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึกการแก้ไข</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
